var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_13465)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1112 7.99978C15.1112 11.9271 11.9274 15.1109 8.00004 15.1109C4.07267 15.1109 0.888916 11.9271 0.888916 7.99978C0.888916 4.07243 4.07267 0.888672 8.00004 0.888672C11.9274 0.888672 15.1112 4.07243 15.1112 7.99978ZM8.88893 4.44423C8.88893 4.93515 8.49096 5.33312 8.00004 5.33312C7.50912 5.33312 7.11115 4.93515 7.11115 4.44423C7.11115 3.95331 7.50912 3.55534 8.00004 3.55534C8.49096 3.55534 8.88893 3.95331 8.88893 4.44423ZM7.11115 7.11089C6.62023 7.11089 6.22226 7.50886 6.22226 7.99978C6.22226 8.4907 6.62023 8.88867 7.11115 8.88867V11.5553C7.11115 12.0463 7.50912 12.4442 8.00004 12.4442H8.88893C9.37985 12.4442 9.77782 12.0463 9.77782 11.5553C9.77782 11.0644 9.37985 10.6665 8.88893 10.6665V7.99978C8.88893 7.50886 8.49096 7.11089 8.00004 7.11089H7.11115Z",
    fill: "black",
    fillOpacity: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_13465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8bb896f42177ee8aceca1778f8051bd4.svg";
export { ForwardRef as ReactComponent };